import {AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild} from '@angular/core';
import Plyr from 'plyr';

@Component({
  selector: 'app-exc-video-viewer',
  templateUrl: './exc-video-viewer.component.html'
})
export class ExcVideoViewerComponent implements AfterViewInit, OnDestroy {
  @Input() src = '';
  @Input() mimeType = 'video/mp4';

  @ViewChild('videoPlayer') videoPlayer!: ElementRef;

  private player: any;
  isLoading = true;

  private syncSeekbarProgress(): void {
    const video = this.videoPlayer.nativeElement as HTMLVideoElement;

    const seekInput = video
      .closest('.plyr')
      ?.querySelector('input[data-plyr="seek"]') as HTMLInputElement;

    if (!seekInput) {
      return;
    }

    video.addEventListener('timeupdate', () => {
      if (!video.duration) {
        return;
      }

      const progress = (video.currentTime / video.duration) * 100;

      seekInput.value = progress.toString();
      seekInput.style.setProperty('--value', `${progress}%`);
      seekInput.setAttribute('aria-valuenow', progress.toString());
    });
  }

  ngAfterViewInit(): void {
  }

  initPlayer(): void {
    this.player = new Plyr(this.videoPlayer.nativeElement, {
      controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
      fullscreen: {
        enabled: true,
        fallback: true,
        iosNative: false
      }
    });

    const videoDoc = this.videoPlayer.nativeElement.ownerDocument;

    if (videoDoc !== document) {
      videoDoc.addEventListener('fullscreenchange', () => {
        if (!videoDoc.fullscreenElement && this.player) {
          const plyrEl = this.videoPlayer.nativeElement.closest('.plyr');
          if (plyrEl) {
            plyrEl.classList.remove('plyr--fullscreen-active');
          }
        }
      });

      this.player.on('ready', () => {
        const fullscreenBtn = this.videoPlayer.nativeElement
          .closest('.plyr')
          ?.querySelector('[data-plyr="fullscreen"]');

        if (fullscreenBtn) {
          const newBtn = fullscreenBtn.cloneNode(true) as Element;
          fullscreenBtn.parentNode.replaceChild(newBtn, fullscreenBtn);

          newBtn.addEventListener('click', (e: Event) => {
            e.stopPropagation();
            e.preventDefault();

            const plyrEl = this.videoPlayer.nativeElement.closest('.plyr');

            if (videoDoc.fullscreenElement) {
              videoDoc.exitFullscreen();
            } else if (plyrEl) {
              plyrEl.requestFullscreen();
            }
          });
        }
      });
      this.player.on('ready', () => {
        this.syncSeekbarProgress();
      });
    }
  }

  ngOnDestroy(): void {
    if (this.player) {
      this.player.destroy();
    }
  }
}
